/**
 * Shared free-form tags across ICR / EEI / Gap / FINTEL / IIR (REPORT) / CT / CM.
 * Uses /api/shared-tags (not corpus /api/tags).
 */

import {firestoreApiFetch} from './firestoreApiClient';

export async function listEntityTags(entityType, entityId) {
    if (!entityType || !entityId) return [];
    const data = await firestoreApiFetch(
        `/api/shared-tags/entities/${encodeURIComponent(entityType)}/${encodeURIComponent(entityId)}`,
    );
    return data?.tags || [];
}

export async function addEntityTag(entityType, entityId, tag) {
    return firestoreApiFetch(
        `/api/shared-tags/entities/${encodeURIComponent(entityType)}/${encodeURIComponent(entityId)}`,
        {method: 'POST', body: JSON.stringify({tag})},
    );
}

export async function removeEntityTag(entityType, entityId, tag) {
    return firestoreApiFetch(
        `/api/shared-tags/entities/${encodeURIComponent(entityType)}/${encodeURIComponent(entityId)}/${encodeURIComponent(tag)}`,
        {method: 'DELETE'},
    );
}

export async function browseSharedTag(tag) {
    if (!tag) return null;
    return firestoreApiFetch(`/api/shared-tags/${encodeURIComponent(tag)}`);
}

export async function suggestSharedTags(q = '', limit = 20) {
    const sp = new URLSearchParams();
    if (q) sp.set('q', q);
    sp.set('limit', String(limit));
    const data = await firestoreApiFetch(`/api/shared-tags?${sp}`);
    return data?.tags || [];
}

/**
 * LLM-driven suggestions for an ICR / EEI / Gap / REPORT.
 * Returns { existingTags: [{name, confidence}], newTags: [{name, confidence}] }.
 */
export async function suggestEntityTags(entityType, entityId, {
    includeNewSuggestions = true,
    confidenceThreshold = 0.5,
} = {}) {
    if (!entityType || !entityId) {
        return {existingTags: [], newTags: []};
    }
    const data = await firestoreApiFetch(
        `/api/shared-tags/entities/${encodeURIComponent(entityType)}/${encodeURIComponent(entityId)}/suggest`,
        {
            method: 'POST',
            body: JSON.stringify({includeNewSuggestions, confidenceThreshold}),
        },
    );
    return {
        existingTags: Array.isArray(data?.existingTags) ? data.existingTags : [],
        newTags: Array.isArray(data?.newTags) ? data.newTags : [],
    };
}
